import { FC } from 'react';
import { Layout, Skeleton } from '..';
import { OfferAlertWrapper } from '../OfferAlert/OfferAlert.styles';
import { CONTAINER_STATE, CONTAINER_TEST_ID } from '../OfferAlert/constants';

interface ILoadingState {
  offerId: string;
}

export const LoadingState: FC<ILoadingState> = ({ offerId }) => (
  <OfferAlertWrapper data-testid={CONTAINER_TEST_ID} data-state={CONTAINER_STATE.LOADING} data-offerid={offerId}>
    <Layout justifyContent="flex-start" marginBottom="12px">
      <Skeleton height="24px" width="200px" />
    </Layout>
    <Layout justifyContent="flex-start">
      <Skeleton height="30px" />
    </Layout>
  </OfferAlertWrapper>
);

LoadingState.displayName = 'OfferAlert_LoadingState';
